import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import { Lamp } from "../../../common/components/organisme/DrawerBtnGroup/assets/icons";
import { SinglePlanBT } from "../../../features/planBT/components/PlanBT/SinglePlanBT";
import {
  ElectricPole,
  Plug,
} from "../../../features/planBT/components/PlanBT/SinglePlanBT/PlanBTImage/PlanBTImageView/assets/icons";
import PolePages from "../PolePages";
import StreetLightPages from "../StreetLightPages";
import styles from "./SinglePlanBTPage.module.scss";
import LinkPages from "../LinkPages";

export default function SinglePlanBTPage() {
  return (
    <>
      <HeaderTitleContent withGoBackBtn goBackTo="/main/plan-bt">
        <SinglePlanBT.Title />
      </HeaderTitleContent>

      <div className={styles["global-container"]}>
        <div className={styles["row"]}>
          <div className={styles["col"]}>
            <SinglePlanBT.Description />
          </div>
          <div className={[styles["col"], styles["col--btn"]].join(" ")}>
            <SinglePlanBT.UpdateBtn />
            <SinglePlanBT.DeleteBtn backTo="/main/plan-bt" />
          </div>
        </div>
        <div className={[styles["row"], styles["row"]].join(" ")}>
          <div className={[styles["col"], styles["col--plan"]].join(" ")}>
            <SinglePlanBT.PlanImage
              contentWidget={[
                {
                  Icon: () => <ElectricPole size={25} color="#878686" />,
                  IconActive: () => <ElectricPole size={25} color="white" />,
                  Content: () => <PolePages />,
                },

                {
                  Icon: () => <Lamp size={25} color="#878686" />,
                  IconActive: () => <Lamp size={25} color="white" />,
                  Content: () => <StreetLightPages />,
                },

                {
                  Icon: () => <Plug size={25} color="#878686" />,
                  IconActive: () => <Plug size={25} color="white" />,
                  Content: () => <LinkPages />,
                },
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}
